const translation = {
  custom: 'カスタマイズ',
  upgradeTip: {
    title: 'プランをアップグレード',
    des: 'ブランドをカスタマイズするためにはプランをアップグレードしてください。',
    prefix: 'プランをアップグレードして',
    suffix: 'ブランドをカスタマイズしましょう。',
  },
  webapp: {
    title: 'WebApp ブランドのカスタマイズ',
    removeBrand: 'Powered by Dify を削除',
    changeLogo: 'Powered by ブランド画像を変更',
    changeLogoTip: '最小サイズ 40x40px の SVG または PNG 形式',
  },
  app: {
    title: 'アプリヘッダーブランドのカスタマイズ',
    changeLogoTip: '最小サイズ 80x80px の SVG または PNG 形式',
  },
  upload: 'アップロード',
  uploading: 'アップロード中',
  uploadedFail: '画像のアップロードに失敗しました。再度アップロードしてください。',
  change: '変更',
  apply: '適用',
  restore: 'デフォルトに戻す',
  customize: {
    contactUs: 'お問い合わせ',
    prefix: 'アプリ内のブランドロゴをカスタマイズするには、',
    suffix: 'エンタープライズ版にアップグレードしてください。',
  },
}

export default translation
